module.exports = __webpack_public_path__ + "img/close-icon-white.3021a994.svg";